import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item =>
        item.QuotationIdAX.toUpperCase().indexOf(value.toUpperCase()) !== -1
      )
      : items;
  }
}

@Pipe({
  name: 'filterLblCart',
  pure: false
})
export class FilterLblCartPipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item =>
        item.ShoppingCartLabel.toUpperCase().indexOf(value.toUpperCase()) !== -1
      )
      : items;
  }
}

@Pipe({
  name: 'filterClient',
  pure: false
})
export class FilterClientPipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item => item.gblClient.name.toUpperCase().indexOf(value.toUpperCase()) !== -1)
      : items;
  }
}

@Pipe({
  name: 'filterProvider',
  pure: false
})
export class FilterProviderPipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item =>
        item.fk_Gbl_Cat_Catalog_Organization_Digital_Media_Type === value.pK_GBL_CAT_CATALOG_ORGANIZATION) : items;
  }
}

@Pipe({
  name: 'filterTemplate',
  pure: false
})
export class FilterTemplatePipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item =>
        item.fk_Gbl_Cat_Catalog_Organization_Digital_Media_Type === value.pK_GBL_CAT_CATALOG_ORGANIZATION) : items;
  }
}
@Pipe({
  name: 'filterTemplateList',
  pure: false
})
export class FilterTemplateListPipe implements PipeTransform {
  transform(items: any[], value): any {
    return value
      ? items.filter(item =>
        item.fk_Gbl_Cat_Catalog_Organization_List_Type === value) : items;
  }
}
@Pipe({
  name: 'sortField',
  pure: false
})
export class ArraySortFiledPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field].toUpperCase() < b[field].toUpperCase()) {
        return -1;
      } else if (a[field].toUpperCase() > b[field].toUpperCase()) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}

@Pipe({
  name: 'sortNumber'
})
export class ArraySortNumberPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
@Pipe({
  name: 'sort'
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
